import React, { useState } from 'react';

export default function LoginPage({ onLogin, authError, onBack }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await onLogin(email, password);
    setIsSubmitting(false);
  };

  return (
    <div className="login-container">
      <div className="login-backdrop" />
      <form className="login-form" onSubmit={handleSubmit}>

        {onBack && (
          <button type="button" onClick={onBack} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', textAlign: 'left', marginBottom: '10px' }}>
            ← Back to Main Website
          </button>
        )}

        <div className="login-logo">
          <img className="login-logo-icon" src="/logo512.png" alt="Chill Ras" />
          <h1 className="login-title">Chill Ras</h1>
          <p className="login-subtitle">Fleet Command Center</p>
        </div>

        {authError && <div className="login-error">{authError}</div>}

        <div className="login-field">
          <label className="login-label" htmlFor="login-email">Email Address</label>
          <input
            id="login-email"
            type="email"
            placeholder="admin@chillras.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
            required
            autoComplete="email"
          />
        </div>

        <div className="login-field">
          <label className="login-label" htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            required
            autoComplete="current-password"
          />
        </div>

        <button
          type="submit"
          className={`login-button ${isSubmitting ? 'login-button--loading' : ''}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <span className="login-spinner" />
          ) : (
            'Authenticate'
          )}
        </button>

        <p className="login-footer">Secured by Firebase Auth</p>
      </form>
    </div>
  );
}
